import React from "react";
import Tap from "../../widgets/Tap";
import seriesTypes from "../../../constants/chart-sidebar/seriesTypes";
import favouriteImage from "../../../assets/images/chart/fav-icon3.png";

export default function ChartSideFavouritesGrid({
  item,
  favourites,
  favouritesIcons,
  seriesType,
  openItem,
  showImageSelector,
  isSelectItem,
  isMultiSelect,
  draggable,
  onDragStart,
  onDragOver,
  onDragEnd,
  style: dragStyle,
}) {
  let src;
  const endSeriesType = seriesType === seriesTypes.mixed.code ? item.$seriesType : seriesType;

  const imageId = favourites[endSeriesType][item.code]?.imageId;

  if (imageId && favouritesIcons[imageId]) {
    src = <img alt="" src={favouritesIcons[imageId].publicUrl} />;
  } else if (item.icon && item.icon.url) {
    src = <img alt="" src={item.icon.url} />;
  } else {
    src = (
      <img
        alt=""
        style={{
          width: "40px",
        }}
        src={favouriteImage}
      />
    );
  }

  const handleLongPress = (_, target) => {
    if (target && target.classList && target.classList.contains("drag-handle")) {
      showImageSelector(item.code, item.$seriesType);
    }
  };

  return (
    <Tap
      tag="button"
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
      className="list-group-item list-group-item-grid"
      short={() => openItem(item)}
      long={handleLongPress}
      style={dragStyle}
    >
      <div className="favourite-icon">{src}</div>
      <div className="code">{item.code}</div>

      <div className="drag-handle">::</div>

      {isMultiSelect && (
        <div style={{ position: "absolute", top: 0, left: "4px" }}>
          <input type="checkbox" checked={isSelectItem} />
        </div>
      )}
    </Tap>
  );
}
